import {
  AlignItems,
  Color,
  Display,
  JustifyContent,
  DisplayPosition,
  ZIndex,
} from '../../theme/tokens';
import { Theme } from '../../theme/types';
import { hexToRGB } from '../../utils';

const getOverlayBackgroundColor = (theme: Theme, opacity: number = 0.7) => {
  const { red, green, blue } = hexToRGB(`${theme.color(Color.ColdGrey_800)}` as `#${string}`);

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};

const modalOverlayStyle = (theme: Theme) => ({
  display: Display.Flex,
  alignItems: AlignItems.Center,
  justifyContent: JustifyContent.Center,
  backgroundColor: getOverlayBackgroundColor(theme),
  zIndex: theme.zIndex(ZIndex.Overlay),
});

const modalContentStyle: React.CSSProperties = {
  borderRadius: 0,
  border: 'none',
  inset: 'initial',
  padding: 0,
  position: DisplayPosition.Relative,
};

export const modalStyle = (theme: Theme) => ({
  content: modalContentStyle,
  overlay: modalOverlayStyle(theme),
});
